import * as React from 'react'

const EntityHeaderTitle = (props: { children: any }) => {
  return <span className='fs-20 font-blue-grey'>{props.children}</span>
}

export default EntityHeaderTitle



// WEBPACK FOOTER //
// ./src/components/ui/entity/EntityHeaderTitle.tsx